import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICellRendererParams } from 'ag-grid-community';
import Swal from 'sweetalert2';

@Component({
  selector: 'piqet-angular-grid-my-project-image',
  templateUrl: './grid-my-project-image.component.html',
  styleUrls: ['./grid-my-project-image.component.css'],
})
export class GridMyProjectImageComponent {
  imgSrc!: string;
  icons: any;

  constructor(private cdref: ChangeDetectorRef, private route: ActivatedRoute) {}

  agInit(params: ICellRendererParams<any, any>): void {
    this.icons =
      params.value ||
      params?.data?.value ||
      params?.data?.scenarioImage ||
      params?.data?.productImage;
    this.icons = this.icons ? (this.icons += `?` + new Date().getTime()) : '';
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    return true;
  }

  onClick(event: any) {
    if (this.route.snapshot.routeConfig?.path == 'scenario-configuration') return;
    const imgElem = event.target;
    const target = event.target || event.srcElement || event.currentTarget;
    const srcAttr = target.attributes.src;
    this.imgSrc = srcAttr.nodeValue;

    Swal.fire({
      imageUrl: this.imgSrc,
      imageWidth: '100%',
      imageHeight: '100%',
      padding: '0px',
      imageAlt: 'Custom image',
      showCancelButton: false,
      showConfirmButton: false,
      backdrop: `
      rgba(217, 217, 217, 0.8)
      url("/images/nyan-cat.gif")
      left top
      no-repeat
    `,
      customClass: {
        image: 'swal2-image-custom-class',
      },
    });
  }
}
